import angular from 'angular'

import './vd-currency-filter'
import { displayRound } from './vd-display-round'
import { dateFromNow } from './vd-date-from-now'
import './vd-highlight-text'
import { imageCdnPath } from './vd-image-cdn-path'
import { userImagePath } from './vd-user-image-path'
import { userName } from './vd-user-name'
import { removeWidow } from './vd-remove-widow'

import './customer/vd-customer-filters'

import { productImagePath } from './vd-product-image-path'
import { toTitleCase } from './vd-title-case.filter'

angular
  .module('vend.ui')
  .filter('vdDateFromNow', () => dateFromNow)
  .filter('vdDisplayRound', () => displayRound)
  .filter('vdImageCdnPath', () => imageCdnPath)
  .filter('vdProductImagePath', () => productImagePath)
  .filter('vdRemoveWidow', () => removeWidow)
  .filter('vdTitleCase', () => toTitleCase)
  .filter('vdUserImagePath', () => userImagePath)
  .filter('vdUserName', () => userName)

export {
  dateFromNow,
  displayRound,
  imageCdnPath,
  removeWidow,
  toTitleCase,
  userName,
}
